/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TbPatientsContacts {
    YES = 'yes',
    NO = 'no',
    DOESNT_KNOW = 'doesntKnow',
}
